import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Checkbox } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { attributeTypes, Images } from 'utils';
import { selectTypeEnums } from '../../attributes/constnats';

export const OptionsSection = ({ selectedItem, handleUpdate }) => {
    const options = selectedItem?.properties?.options || [];

    const handleOptionChange = (index, key, newVal) => {
        const newOptions = [...options];
        newOptions[index] = { ...newOptions[index], [key]: newVal };
        if (key === 'name') {
            newOptions[index].value = newVal;
        }

        handleUpdate('options', newOptions);
    };

    const addOption = () => {
        const newOptions = [...options, { id: uuidv4(), name: '', value: '' }];
        handleUpdate('options', newOptions);
    };

    const removeOption = (index) => {
        const newOptions = options.filter((_, i) => i !== index);
        handleUpdate('options', newOptions);
    };

    const toggleDefault = (opt) => {
        if (selectedItem.type === attributeTypes.CHECK_BOX) {
            let currentValue = selectedItem.value;
            if (!Array.isArray(currentValue)) currentValue = [];
            const exists = currentValue.some((v) => v?.id === opt.id);
            let newValue;
            if (exists) {
                newValue = currentValue.filter((v) => v?.id !== opt.id);
            } else {
                newValue = [...currentValue, { name: opt.name, id: opt.id }];
            }
            handleUpdate('value', newValue);
        } else if (selectedItem.type === attributeTypes.SELECT && selectedItem.defaultDateType === selectTypeEnums.MULTIPLE) {
            let currentValue = selectedItem.value;
            if (!Array.isArray(currentValue)) currentValue = [];

            const exists = currentValue.some((v) => v?.id === opt.id);

            let newValue;
            if (exists) {
                newValue = currentValue.filter((v) => v?.id !== opt.id);
            } else {
                newValue = [...currentValue, { name: opt.name, id: opt.id }];
            }
            handleUpdate('value', newValue);
        } else {
            const isSelected = selectedItem.value && selectedItem.value.id === opt.id;
            handleUpdate('value', isSelected ? null : { name: opt.name, id: opt.id });
        }
    };

    const isChecked = (opt) => {
        if (selectedItem.type === attributeTypes.CHECK_BOX) {
            const val = selectedItem.value;
            if (Array.isArray(val)) {
                return val.some((v) => v?.id === opt.id);
            }
            return false;
        }
        if (selectedItem.type === attributeTypes.SELECT && selectedItem.defaultDateType === selectTypeEnums.MULTIPLE) {
            const val = selectedItem.value;
            if (Array.isArray(val)) {
                return val.some((v) => v?.id === opt.id);
            }
            return false;
        }
        return selectedItem?.value?.id === opt.id;
    };

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(options);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        handleUpdate('options', items);
    };

    return (
        <div className="properties-section" style={{ padding: 0 }}>
            <div className="props-label" style={{ marginBottom: 8 }}>
                Options
            </div>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="options-list">
                    {(provided) => (
                        <div className="column" {...provided.droppableProps} ref={provided.innerRef}>
                            {options?.map((opt, i) => (
                                <Draggable key={opt.id || i} draggableId={opt.id || `opt-${i}`} index={i}>
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            className="flex-align-center full-width"
                                            style={{ ...provided.draggableProps.style, gap: 8, marginBottom: 8 }}
                                        >
                                            <Checkbox
                                                onClick={() => toggleDefault(opt)}
                                                style={{ padding: 0, color: isChecked(opt) ? '#0C66E4' : '#D0D5DD' }}
                                                checked={isChecked(opt)}
                                            />
                                            <div className="option-input-box">
                                                <div
                                                    {...provided.dragHandleProps}
                                                    style={{ display: 'flex', alignItems: 'center', cursor: 'grab', marginRight: 4 }}
                                                >
                                                    <img src={Images.dragIcon} alt="drag" />
                                                </div>
                                                <input value={opt.name} onChange={(e) => handleOptionChange(i, 'name', e.target.value)} />
                                            </div>
                                            <div
                                                onClick={() => removeOption(i)}
                                                style={{ cursor: 'pointer', opacity: 0.6, fontSize: 16, padding: '0 4px' }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="10"
                                                    height="10"
                                                    viewBox="0 0 10 10"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M9.70859 1.70859C10.0992 1.31797 10.0992 0.683594 9.70859 0.292969C9.31797 -0.0976562 8.68359 -0.0976562 8.29297 0.292969L5.00234 3.58672L1.70859 0.296094C1.31797 -0.0945312 0.683594 -0.0945312 0.292969 0.296094C-0.0976562 0.686719 -0.0976562 1.32109 0.292969 1.71172L3.58672 5.00234L0.296094 8.29609C-0.0945312 8.68672 -0.0945312 9.32109 0.296094 9.71172C0.686719 10.1023 1.32109 10.1023 1.71172 9.71172L5.00234 6.41797L8.29609 9.70859C8.68672 10.0992 9.32109 10.0992 9.71172 9.70859C10.1023 9.31797 10.1023 8.68359 9.71172 8.29297L6.41797 5.00234L9.70859 1.70859Z"
                                                        fill="#667085"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            <div className="full-width">
                <button className="add-option-btn" onClick={addOption}>
                    <img src={Images.addBluePlus} alt="pluseIcone" />
                    <span>Add Option</span>
                </button>
            </div>
        </div>
    );
};
